// extracted by mini-css-extract-plugin
export default {"header-text":"styles_header-text__bWpUC","h1":"styles_h1__w+JCZ","root":"styles_root__kGw3W"};